import * as React from 'react';
import { Button } from '@cian/ui-kit/prev/button';
import { Text } from '@cian/ui-kit/prev/text';
import { Link } from '../../Link';
import * as styles from './AuthenticateMotivation.css';
import { AuthenticateMotivationIcon } from './AuthenticateMotivationIcon';

export interface IAuthenticateMotivationProps {
  url: string;
  onAuthLinkClick(): void;
}

export function AuthenticateMotivation({ url, onAuthLinkClick }: IAuthenticateMotivationProps) {
  return (
    <div className={styles['authenticate_motivation']}>
      <div className={styles['authenticate_motivation-icon']}>
        <AuthenticateMotivationIcon />
      </div>
      <p className={styles['authenticate_motivation-title']}>
        Жилой комплекс добавлен{' '}
        <Link url="/favorites/">
          <Text
            styles={{
              color: '2B87DB',
              fontSize: '22',
              fontWeight: 'bold',
            }}
          >
            в избранное
          </Text>
        </Link>
      </p>
      <p className={styles['authenticate_motivation-text']}>
        Авторизуйтесь, чтобы получить доступ к избранному с любого устройства
      </p>
      <div className={styles['authenticate_motivation-button']}>
        <Link url={`/authenticate/${url}`}>
          <Button custom={{ type: 'secondary' }} onClick={onAuthLinkClick}>
            Авторизоваться
          </Button>
        </Link>
      </div>
    </div>
  );
}
